module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 74.6fc3312b.png";